export const PREFIX = 'prefix';
export const NAME = 'className';
export const DISTANCE = 'distance';
export const UNITS = 'units';
export const LISTORDER = 'listOrder';
export const STARTORDER = 'startOrder';
export const STARTTS = 'startTs';
